import { AxiosInstance } from "axios";
import { Fenetre } from "../types/Fenetre";
import { SousFenetre } from "../types/SousFenetre";

export const FenetreService = {

  getByIdMenu: async (api: AxiosInstance, idMenu: number): Promise<Fenetre[]> => {
    try {
      const response = await api.get(`/fenetre-management/fenetres-menu/${idMenu}`);

      return response.data.map((fenetre: any): Fenetre => ({
        id: fenetre.idFenetre,
        nom: fenetre.nomFenetre,
        titre: fenetre.titre,
        tbl_name: fenetre.tblName,
        id_menu: fenetre.menu?.idMenu ?? 0,
        is_active: fenetre.isActive,
        icon_label: fenetre.iconLabel ?? fenetre.menu?.icon_label ?? "",
      }));

    } catch (error) {
      console.error("Erreur lors de la récupération des fenêtres :", error);
      throw error;
    }
  },

  addFenetre: async (api: AxiosInstance, fenetre: Fenetre): Promise<Fenetre> => {
    try {
      
      const payload = {
        titre: "",
        tblName: fenetre.tbl_name,
        nomFenetre: fenetre.nom,
        iconLabel: fenetre.icon_label,
        menu: { idMenu: fenetre.id_menu },
        isActive: fenetre.is_active ?? true,
      };

      const response = await api.post("/fenetre-management/add-fenetre", payload);
      const data = response.data;

      return {
        id: data.idFenetre,
        nom: data.nomFenetre,
        titre: "",
        tbl_name: data.tblName,
        id_menu: data.menu?.idMenu ?? fenetre.id_menu,
        is_active: data.isActive,
        icon_label: data.iconLabel,
      };

    } catch (error: any) {
      console.error("Erreur lors de l'ajout de la fenêtre :", error);

      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }

      throw error;
    }
  },

  addSousFenetre: async (api: AxiosInstance, sousFenetre: SousFenetre): Promise<SousFenetre> => {
    try {
      const payload = {
        nomSousFenetre: sousFenetre.nomSousFenetre,
        tblName: sousFenetre.tblName,
        fenetre: {
          idFenetre: sousFenetre.fenetre.id,
        },
      };

      const response = await api.post("/sous-fenetre-management/add-sous-fenetre", payload);
      const data = response.data;

      return {
        idSousFenetre: data.idSousFenetre,
        nomSousFenetre: data.nomSousFenetre,
        tblName: data.tblName,
        titre: "",
        fenetre: {
          id: data.fenetre?.idFenetre,
        },
      };
      
    } catch (error: any) {
      console.error("Erreur lors de l'ajout de la sous-fenêtre :", error);
      
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }

      throw error;
    }
  },
  
  getByIdFenetre: async (api: AxiosInstance, idFenetre: number): Promise<SousFenetre[]> => {
    try {
      const response = await api.get(`/sous-fenetre-management/sous-fenetres-fenetre/${idFenetre}`);

      return response.data.map((sf: any): SousFenetre => ({
        idSousFenetre: sf.idSousFenetre,
        nomSousFenetre: sf.nomSousFenetre,
        tblName: sf.tblName,
        titre: sf.titre,
        fenetre: {
          id: sf.fenetre?.id,
        },
      }));

    } catch (error: any) {
      console.error("Erreur lors de la récupération des sous-fenêtres :", error);
      throw error;
    }
  },

  enableFenetre: async (api: AxiosInstance, id: number): Promise<number> => {
    try {
      const response = await api.put(`/fenetre-management/enable/${id}`);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de l'activation de la fenêtre ${id}:`, error);
      if (error.response?.data) throw new Error(error.response.data);
      throw error;
    }
  },

  disableFenetre: async (api: AxiosInstance, id: number): Promise<number> => {
    try {
      const response = await api.put(`/fenetre-management/disable/${id}`);
      return response.data;
    } catch (error: any) {
      console.error(`Erreur lors de la désactivation de la fenêtre ${id}:`, error);
      if (error.response?.data) throw new Error(error.response.data);
      throw error;
    }
  }

};
